module.exports = __webpack_public_path__ + "media/images/emblems/Beckenried-coat_of_arms-d0dfcdef977dd84200bd024382e4dd31.svg";